import React, { useRef, useState, useEffect } from 'react';
import {
  MenuListItem,
  Input,
  Menu,
  IconArrowDropUp,
  IconArrowDropDown,
  StyledBaseInputField,
} from 'cdk-radial';
import styled from 'styled-components';

type Options = {
  label: string;
  value: string | boolean | any;
};

interface ICommonSelector {
  options: Options[];
  selectedOption: Options;
  placeholder: string;
  label: string;
  name:string,
  onSelect:any,
  isRequired:boolean,
}

const StyledInput = styled(Input)`
  ${StyledBaseInputField} {
    cursor: pointer;
  }
  svg {
    cursor: pointer;
  }
`;

export const StyledDropDownContainer = styled.div`
  width: auto;
`
export const StyledMenu = styled(Menu)`
  z-index: 105 !important;
  width: 100%;
  max-width: 20% !important;

`;
export const CommonDropdown = ({options,label,name,placeholder,selectedOption,onSelect,isRequired}:Partial<ICommonSelector>) => {
  
    /**
     * Lifecycle hooks
     */
    const targetRef = useRef();
    const dimensionRef = useRef();

    /**
     * local state hooks
     */
    const [isOpen, setIsOpen] = useState<boolean>(true);
    const [dropdownSelectedOption, setDropdownSelectedOption] = useState(selectedOption);

    /**
     * Side effects
     */
    const handleOpen = () => setIsOpen((isOpen) => !isOpen);

    const handleSelect = (option:Options,name:string) => {
        setDropdownSelectedOption(option);
        onSelect && onSelect(option);
    };
  
    useEffect(() => {
      setDropdownSelectedOption(selectedOption);
    }, [selectedOption]);


    return (
        <>
            <StyledDropDownContainer >
                <StyledInput
                    dataTestId={`${label}-select-menu-input`}
                    icon={isOpen ? <IconArrowDropDown /> : <IconArrowDropUp />}
                    id={`${label}-select-dropdown`}
                    label={label}
                    labelRef={dimensionRef}
                    name={label}
                    placeholder={placeholder}
                    ref={targetRef}
                    onChange={()=>{}}
                    value={dropdownSelectedOption?.label || ''}
                    style={{ caretColor: 'transparent' }}
                    autoComplete={"off"}
                    isRequired={isRequired}
                />
            </StyledDropDownContainer>
            <StyledMenu
                dataTestId="menu-container"
                dimensionRef={dimensionRef}
                labelRef={targetRef}
                onClose={handleOpen}
                onOpen={handleOpen}
                isAuto={false}
            >
                {options?.map((option:any, ind:any) => (
                    <MenuListItem
                     dataTestId={`menu-item-${ind}`}
                     isDisabled={option?.disabled}
                     isSelected={option.value === dropdownSelectedOption?.value}
                     key={ind}
                     onClick={() => handleSelect(option,name as string)}
                     hideSelectedItemCheckmark={false}
                    >
                     {option.label}
                    </MenuListItem>
                ))}
            </StyledMenu>
        </>
    );
};
